<template>
  <div>
    <Modal v-model="isShow" width="600" :mask-closable="false" @on-ok="ok" :loading="loading">
      <h3 slot="header" class="modal-header">{{projectUpdateName}}</h3>
      <Row class="row ">
        <Col span="4">序号</Col>
        <Col span="6">班次</Col>
        <Col span="8">起止时间</Col>
        <Col span="6">操作</Col>
      </Row>
      <Row v-for="(item,index) in dataList" class="row" :key="'row'+index">
        <Col span="4">{{index+1}}</Col>
        <Col span="6">
          <Input class="input" v-model="item.scheduleConfigName"/>
        </Col>
        <Col span="8">
          <TimePicker :clearable="false" type="timerange" format="HH:mm" v-model="item.timeData"></TimePicker>
        </Col>
        <Col span="6">
          <a @click.stop="deleteItem(index)">删除</a>
        </Col>
      </Row>
      <div class="mt20">
        <a @click.stop="addBanci">+ 添加</a>
      </div>
      <div class="mt20">
        <Checkbox v-model="isSync"> 同步到权限内其他所有项目</Checkbox>
      </div>
    </Modal>
  </div>
</template>

<script>
  import Vue from 'vue'

  import {deepClone} from "../../../../../utils/format";

  export default {
    components: {
      // TypeItem
    },
    // name: "BanciUpdate"
    props: {
      projectUpdateName:{
        type:String,
        default:''

      },
      n: {
        type: Number,
        default: 0
      },
      dataListOri: {
        type: Array,
        default: null
      }
    },
    data() {
      return {
        isShow: false,
        type: 'timerange',
        dataList: [],
        loading: true,
        isSync: false
      }
    },
    watch: {
      n() {
        this.isSync=false
        this.isShow = true
        this.initDataList(this.dataListOri)
      },
      dataListOri(value) {
        if (!value) {
          return
        }
        this.initDataList(value)
      }
    },
    methods: {
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok() {
        this.dataList.forEach(ele => {
          ele.startTime = ele.timeData[0]
          ele.endTime = ele.timeData[1]
        })
        var flag = true
        this.dataList.forEach(ele => {
          if (!ele.scheduleConfigName) {
            flag = false
          }
        })
        if (!flag) {
          // this.isShow=true
          this.$Message.info('班次名称不能为空')
          this.changeLoading()
        }
        else {
          this.$emit('update', this.dataList, this.isSync)
          this.isShow=false
        }
      },
      initDataList(value) {
        var t = deepClone(value)
        t.forEach(ele => {
          ele['timeData'] = [ele.startTime, ele.endTime]
        })
        this.dataList = t
      },
      deleteItem(index) {
        this.$Modal.confirm({
          title: '班次删除',
          content: '<p>确认删除？</p>',
          onOk: () => {
            this.dataList.splice(index, 1)
          }
        })
      },
      addBanci() {
        if(this.dataList.length>=6){
          this.$Message.info('最多不超过6个班次')
          return
        }
        this.dataList.push({
          "endTime": "",
          "scheduleConfigName": "",
          "startTime": "",
          "timeData": ['00:00', '00:00']
        })
      },
    }
  }
</script>
<style scoped>
  .input {
    display: inline-block;
    width: 100px;
  }

  .row {
    text-align: center;
    /*margin-bottom: 10px;*/
    line-height: 32px;

    border-left: 1px solid rgb(222, 222, 222);
    border-right: 1px solid rgb(222, 222, 222);
    border-bottom: 1px solid rgb(222, 222, 222);
    padding: 7px;
  }

  .row:first-child {
    border-top: 1px solid rgb(222, 222, 222);
    background-color: rgb(248, 248, 248);
    padding: 5px;
  }
  .row:last-child {

  }

</style>
